export type NameFilterInput = {
  nameFilter: string;
  loading: boolean;
  active: boolean;
};

export const useAsyncCombinedFilter = (
  filterString: string,
  nameFilters: NameFilterInput[],
): {
  filter: string;
  nameFiltersLoading: boolean;
  resolvedNameFilterEmpty: boolean;
} => {
  const filter = [filterString, ...nameFilters.map(f => f.nameFilter)]
    .filter(Boolean)
    .join(' AND ');

  const nameFiltersLoading = nameFilters.some(f => f.active && f.loading);
  const resolvedNameFilterEmpty = nameFilters.some(
    f => f.active && !f.loading && !f.nameFilter,
  );

  return { filter, nameFiltersLoading, resolvedNameFilterEmpty };
};
